/*
  Kod rabatowy w koszyku (drawer).

  Aplikuje kod przez Ajax Cart API: POST /cart/update.js z parametrem `discount`
  (wsparcie od 2025-05). Dzięki temu rabat jest widoczny w koszyku OD RAZU
  (cart.total_price + cart.cart_level_discount_applications), a nie dopiero w kasie.

  Wcześniej używano /discount/{code} — ten endpoint tylko zapisuje kod do sesji
  checkoutu i NIE zmienia obiektu cart na storefroncie, stąd "działa tylko w kasie".

  Logika jest delegowana na document (nie bindowana do konkretnego przycisku),
  więc działa też po każdym przerenderowaniu drawera — cart-drawer.js podmienia
  zawartość przez innerHTML, a wstawione tak <script> się nie wykonują.
*/
(function () {
  if (window.SelvaCartDiscount) return;
  window.SelvaCartDiscount = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function cartUpdateUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/update.js';
    }
    return '/cart/update.js';
  }

  function setNotice(msg, color) {
    var notice = document.getElementById('CartDrawer-DiscountNotice');
    if (!notice) return;
    notice.textContent = msg || '';
    notice.style.color = color || '#333';
    notice.style.display = msg ? 'block' : 'none';
  }

  function setBtnLoading(loading) {
    var btn = document.getElementById('CartDrawer-DiscountApply');
    if (!btn) return;
    btn.disabled = loading;
    btn.textContent = loading ? '…' : 'Wykorzystaj kupon';
  }

  function rerenderDrawer(cart) {
    if (!cart || !cart.sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(cart);
      return;
    }
    // Fallback: ręczna podmiana zawartości drawera
    var html = cart.sections['cart-drawer'];
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#CartDrawer');
    var cur = document.getElementById('CartDrawer');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }

  /*
    Czy kod faktycznie się zastosował (zwraca true/false).
    Preferuje cart.discount_codes z flagą applicable (potwierdzone na żywym API:
    zły kod => {code, applicable:false}). Gdy brak tego pola w JSON — fallback na
    tytuły w aplikacjach rabatu (dla kodu rabatowego title === kod).
    Uwaga: Shopify zwraca applicable:false zarówno dla literówki, jak i dla kodu
    niespełniającego warunków — nie da się ich rozróżnić, stąd jeden komunikat błędu.
  */
  function discountApplied(cart, code) {
    var target = code.toLowerCase();
    if (cart && Array.isArray(cart.discount_codes)) {
      for (var i = 0; i < cart.discount_codes.length; i++) {
        var entry = cart.discount_codes[i];
        if ((entry.code || '').toLowerCase() === target) {
          return entry.applicable === true;
        }
      }
      return false;
    }
    var apps = (cart && cart.cart_level_discount_applications) || [];
    for (var j = 0; j < apps.length; j++) {
      if ((apps[j].title || '').toLowerCase() === target) return true;
    }
    var items = (cart && cart.items) || [];
    for (var k = 0; k < items.length; k++) {
      var d = items[k].discounts || [];
      for (var m = 0; m < d.length; m++) {
        if ((d[m].title || '').toLowerCase() === target) return true;
      }
    }
    return false;
  }

  function applyDiscount(code) {
    setBtnLoading(true);
    setNotice('', '');

    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code, sections: SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          return { ok: r.ok, cart: body };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          setBtnLoading(false);
          setNotice('Nieprawidłowy kod rabatowy.', '#c00');
          return;
        }
        var applied = discountApplied(res.cart, code);
        rerenderDrawer(res.cart);

        // Element jest nowy po re-renderze — ustawiamy wartości na świeżych węzłach
        var input = document.getElementById('CartDrawer-DiscountCode');
        if (input) input.value = applied ? code : '';

        if (applied) {
          setNotice('Kod „' + code + '” zastosowany.', '#2a7a2a');
        } else {
          setNotice('Nie udało się zastosować kodu „' + code + '”. Sprawdź pisownię i warunki promocji.', '#c00');
        }
        setBtnLoading(false);
      })
      .catch(function () {
        setBtnLoading(false);
        setNotice('Nie można zastosować kodu. Spróbuj ponownie.', '#c00');
      });
  }

  function handleApply() {
    var input = document.getElementById('CartDrawer-DiscountCode');
    var code = input ? input.value.trim() : '';
    if (!code) {
      setNotice('Wpisz kod rabatowy.', '#c00');
      return;
    }
    applyDiscount(code);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('#CartDrawer-DiscountApply')) {
      e.preventDefault();
      handleApply();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    if (e.target.closest('#CartDrawer-DiscountCode')) {
      e.preventDefault();
      handleApply();
    }
  });
})();